/*
  rg-leg-selector.js — The Rustic Grove Co.

  Drives the six-tile leg selector (snippets/rg-leg-selector.liquid). The tiles
  are visual radios; this script:
    1. Writes the chosen tile's style + colour into the hidden
       properties[Leg style] / properties[Leg colour] inputs, so the cart/order
       carries the same two line-item properties as the old two controls did.
    2. Reflects the chosen value beside the "Legs" label.
    3. Exposes the current selection as data-current-leg-style /
       data-current-leg-colour on the selector root.
    4. Dispatches a bubbling `leg:change` CustomEvent { style, colour } so the
       gallery can re-filter on leg changes — mirroring how the variant picker
       drives the gallery via variantChange.

  One tile is selected on load (server-rendered `checked`); the hidden inputs are
  pre-populated server-side, so an order always carries leg values even if the
  customer never touches the selector.

  Deep-link support (added): if the page URL carries a `legs` query parameter
  (e.g. ?legs=trapezium-black, &legs=square-steel), the matching tile is
  preselected on load exactly as if the customer had clicked it — so a
  leg-specific Shopping ad lands on the leg its image promised. Format is
  "<style>-<colour>"; matching is normalised (case- and hyphen-insensitive), so
  aframe/a-frame, Black/black all resolve. An absent or unrecognised value is a
  no-op — the server default stands and the picker is never broken by bad input.
*/
(function () {
  function init(root) {
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-rg-leg-input]'));
    if (!inputs.length) return;

    var styleProp = root.querySelector('[data-rg-leg-prop="style"]');
    var colourProp = root.querySelector('[data-rg-leg-prop="colour"]');
    var readout = root.querySelector('[data-rg-leg-value]');

    function apply(input, emit) {
      var style = input.getAttribute('data-leg-style') || '';
      var colour = input.getAttribute('data-leg-colour') || '';

      if (styleProp) styleProp.value = style;
      if (colourProp) colourProp.value = colour;

      root.setAttribute('data-current-leg-style', style.toLowerCase());
      root.setAttribute('data-current-leg-colour', colour.toLowerCase());

      if (readout) readout.textContent = ': ' + style + ' · ' + colour;

      if (emit) {
        root.dispatchEvent(
          new CustomEvent('leg:change', {
            bubbles: true,
            detail: { style: style, colour: colour },
          })
        );
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) apply(input, true);
      });
    });

    // Establish initial state (readout + hidden props + data attributes) from the
    // server-selected tile, without emitting — the gallery's own server render
    // already matches this default, so there is nothing to re-filter on load.
    var checked = inputs.filter(function (i) { return i.checked; })[0] || inputs[0];
    checked.checked = true;
    apply(checked, false);

    // --- Deep-link: preselect a leg from the ?legs= URL parameter -----------
    // Lets leg-specific Shopping ads land on the leg shown in their image.
    // Never throws into the page: any problem falls back to the server default.
    try {
      var raw = new URLSearchParams(window.location.search).get('legs');
      if (raw) {
        var norm = function (s) {
          return (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        };
        var wanted = norm(raw); // e.g. "trapeziumblack"
        var match = inputs.filter(function (i) {
          return (
            norm(i.getAttribute('data-leg-style') + i.getAttribute('data-leg-colour')) === wanted
          );
        })[0];
        if (match && match !== checked) {
          inputs.forEach(function (i) { i.checked = false; });
          match.checked = true;
          apply(match, true); // emit so the gallery re-filters to the matching image
        }
      }
    } catch (e) {
      /* no-op: a bad ?legs= value must never break the selector */
    }
  }

  function boot() {
    document.querySelectorAll('[data-rg-leg-selector]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
